module.exports = __webpack_public_path__ + "static/media/triangolo_ricetta.9e52f953.svg";